// src/pages/DailyProfitColumns.ts
export type DailyRow = {
    // 基本情報
    label?: string;
    report_date?: string;
    weekday_jp?: string;
    weekday_jp_ly?: string;

    // 売上
    sales?: number | null;
    coupon_shop?: number | null;
    coupon_rate?: number | null;

    // アクセス人数
    visit_ly?: number | null;
    visit?: number | null;
    visit_yoy?: number | null;

    // 売上件数
    order_count_ly?: number | null;
    order_count?: number | null;
    order_count_yoy?: number | null;

    // 転換率
    cvr_ly?: number | null;
    cvr?: number | null;
    cvr_yoy?: number | null;

    // 客単価
    unit_price_ly?: number | null;
    unit_price?: number | null;
    unit_price_yoy?: number | null;

    // 限界利益
    marginal_profit?: number | null;
    marginal_profit_rate?: number | null;

    // 固定費
    fixed_cost_daily?: number | null;

    // 営業利益
    operating_profit?: number | null;
    operating_profit_rate?: number | null;

    // 費用合計
    total_expense?: number | null;
    total_expense_rate?: number | null;

    // 原価
    cost_amount?: number | null;
    cost_amount_rate?: number | null;

    // 楽天手数料
    fee?: number | null;
    fee_rate?: number | null;

    // 物流コスト
    logistics_cost?: number | null;
    logistics_cost_rate?: number | null;

    // 販促費合計
    total_advertising?: number | null;
    total_advertising_rate?: number | null;

    // ポイント費用
    point_amount_spent?: number | null;
    point_amount_spent_rate?: number | null;

    // メルマガ費用
    mail_amount_spent?: number | null;
    mail_amount_spent_rate?: number | null;

    // アフィリエイト費用
    afl_amount_spent?: number | null;
    afl_amount_spent_rate?: number | null;

    // 広告費合計
    total_promotion?: number | null;
    total_promotion_rate?: number | null;

    // 純広告
    ec_amount_spent?: number | null;
    ec_amount_spent_rate?: number | null;

    // RPP広告
    rpp_amount_spent?: number | null;
    rpp_amount_spent_rate?: number | null;

    // RPP-EXP広告
    rppexp_amount_spent?: number | null;
    rppexp_amount_spent_rate?: number | null;

    // 楽天CPA広告
    cpa_amount_spent?: number | null;
    cpa_amount_spent_rate?: number | null;

    // CA広告
    cpnadv_amount_spent?: number | null;
    cpnadv_amount_spent_rate?: number | null;

    // TDA広告
    tda_amount_spent?: number | null;
    tda_amount_spent_rate?: number | null;

    // TDA-EXP
    tdaexp_amount_spent?: number | null;
    tdaexp_amount_spent_rate?: number | null;

    // DEAL報酬
    deal_amount_spent?: number | null;
    deal_amount_spent_rate?: number | null;

    // 楽天外広告費（最大3科目）
    non_rakuten_ad_1_name?: string | null;
    non_rakuten_ad_1_cost?: number | null;
    non_rakuten_ad_1_cost_rate?: number | null;
    non_rakuten_ad_2_name?: string | null;
    non_rakuten_ad_2_cost?: number | null;
    non_rakuten_ad_2_cost_rate?: number | null;
    non_rakuten_ad_3_name?: string | null;
    non_rakuten_ad_3_cost?: number | null;
    non_rakuten_ad_3_cost_rate?: number | null;
};

export type ColumnType = "num" | "rate";

export type ColumnDef = {
    key: keyof DailyRow;
    title: string;
    group: string;
    type: ColumnType;
};

export const COLUMN_DEFS = [
    // 売上
    { key: "sales", title: "売上", group: "売上", type: "num" },
    { key: "coupon_shop", title: "クーポン値引額", group: "売上", type: "num" },
    { key: "coupon_rate", title: "比率", group: "売上", type: "rate" },

    // アクセス人数
    { key: "visit_ly", title: "昨年", group: "アクセス人数", type: "num" },
    { key: "visit", title: "当月", group: "アクセス人数", type: "num" },
    { key: "visit_yoy", title: "昨対比率", group: "アクセス人数", type: "rate" },

    // 売上件数
    { key: "order_count_ly", title: "昨年", group: "売上件数", type: "num" },
    { key: "order_count", title: "当月", group: "売上件数", type: "num" },
    { key: "order_count_yoy", title: "昨対比率", group: "売上件数", type: "rate" },

    // 転換率
    { key: "cvr_ly", title: "昨年", group: "転換率", type: "rate" },
    { key: "cvr", title: "当月", group: "転換率", type: "rate" },
    { key: "cvr_yoy", title: "昨対比率", group: "転換率", type: "rate" },

    // 客単価
    { key: "unit_price_ly", title: "昨年", group: "客単価", type: "num" },
    { key: "unit_price", title: "当月", group: "客単価", type: "num" },
    { key: "unit_price_yoy", title: "昨対比率", group: "客単価", type: "rate" },

    // 限界利益
    { key: "marginal_profit", title: "限界利益額", group: "限界利益", type: "num" },
    { key: "marginal_profit_rate", title: "比率", group: "限界利益", type: "rate" },

    // 固定費
    { key: "fixed_cost_daily", title: "固定費", group: "固定費", type: "num" },

    // 営業利益
    { key: "operating_profit", title: "営業利益", group: "営業利益", type: "num" },
    { key: "operating_profit_rate", title: "比率", group: "営業利益", type: "rate" },

    // 費用合計
    { key: "total_expense", title: "費用合計", group: "費用合計", type: "num" },
    { key: "total_expense_rate", title: "比率", group: "費用合計", type: "rate" },

    // 原価
    { key: "cost_amount", title: "原価額", group: "原価", type: "num" },
    { key: "cost_amount_rate", title: "比率", group: "原価", type: "rate" },

    // 手数料
    { key: "fee", title: "販売＋決済手数料", group: "手数料", type: "num" },
    { key: "fee_rate", title: "比率", group: "手数料", type: "rate" },

    // 物流コスト
    { key: "logistics_cost", title: "物流費", group: "物流コスト", type: "num" },
    { key: "logistics_cost_rate", title: "比率", group: "物流コスト", type: "rate" },

    // 販促費
    { key: "total_advertising", title: "販促費合計", group: "販促費", type: "num" },
    { key: "total_advertising_rate", title: "比率", group: "販促費", type: "rate" },
    { key: "point_amount_spent", title: "ポイント費用", group: "販促費", type: "num" },
    { key: "point_amount_spent_rate", title: "比率", group: "販促費", type: "rate" },
    { key: "mail_amount_spent", title: "メルマガ費用", group: "販促費", type: "num" },
    { key: "mail_amount_spent_rate", title: "比率", group: "販促費", type: "rate" },
    { key: "afl_amount_spent", title: "アフィリ費用", group: "販促費", type: "num" },
    { key: "afl_amount_spent_rate", title: "比率", group: "販促費", type: "rate" },
    { key: "total_promotion", title: "楽天広告費合計", group: "販促費", type: "num" },
    { key: "total_promotion_rate", title: "比率", group: "販促費", type: "rate" },

    // 楽天広告費内訳
    { key: "ec_amount_spent", title: "純広告", group: "楽天広告費内訳", type: "num" },
    { key: "ec_amount_spent_rate", title: "比率", group: "楽天広告費内訳", type: "rate" },
    { key: "rpp_amount_spent", title: "RPP広告", group: "楽天広告費内訳", type: "num" },
    { key: "rpp_amount_spent_rate", title: "比率", group: "楽天広告費内訳", type: "rate" },
    { key: "rppexp_amount_spent", title: "RPP-EXP広告", group: "楽天広告費内訳", type: "num" },
    { key: "rppexp_amount_spent_rate", title: "比率", group: "楽天広告費内訳", type: "rate" },
    { key: "cpa_amount_spent", title: "楽天CPA広告", group: "楽天広告費内訳", type: "num" },
    { key: "cpa_amount_spent_rate", title: "比率", group: "楽天広告費内訳", type: "rate" },
    { key: "cpnadv_amount_spent", title: "CA広告", group: "楽天広告費内訳", type: "num" },
    { key: "cpnadv_amount_spent_rate", title: "比率", group: "楽天広告費内訳", type: "rate" },
    { key: "tda_amount_spent", title: "TDA広告", group: "楽天広告費内訳", type: "num" },
    { key: "tda_amount_spent_rate", title: "比率", group: "楽天広告費内訳", type: "rate" },
    { key: "tdaexp_amount_spent", title: "TDA-EXP", group: "楽天広告費内訳", type: "num" },
    { key: "tdaexp_amount_spent_rate", title: "比率", group: "楽天広告費内訳", type: "rate" },
    { key: "deal_amount_spent", title: "DEAL報酬", group: "楽天広告費内訳", type: "num" },
    { key: "deal_amount_spent_rate", title: "比率", group: "楽天広告費内訳", type: "rate" },

    // 楽天外広告費（タイトルはプレースホルダー。DailyProfitPage でデータから上書き）
    { key: "non_rakuten_ad_1_cost", title: "楽天外広告①", group: "楽天外広告費①", type: "num" },
    { key: "non_rakuten_ad_1_cost_rate", title: "比率", group: "楽天外広告費①", type: "rate" },
    { key: "non_rakuten_ad_2_cost", title: "楽天外広告②", group: "楽天外広告費②", type: "num" },
    { key: "non_rakuten_ad_2_cost_rate", title: "比率", group: "楽天外広告費②", type: "rate" },
    { key: "non_rakuten_ad_3_cost", title: "楽天外広告③", group: "楽天外広告費③", type: "num" },
    { key: "non_rakuten_ad_3_cost_rate", title: "比率", group: "楽天外広告費③", type: "rate" },
] as const satisfies readonly ColumnDef[];

// ✅ Period側もこれを import して使う（ページ側で再定義しない）
export type MetricKey = (typeof COLUMN_DEFS)[number]["key"];

// -------------------------------
// 段組み定義
// -------------------------------
export type HeaderSubGroupDef = {
    name: string;
    groups: readonly string[];
};

export type HeaderSectionDef =
    | { top: string; sub: readonly HeaderSubGroupDef[] }
    | { top: string; groups: readonly string[]; rowSpan2?: true };

export const HEADER_STRUCTURE: readonly HeaderSectionDef[] = [
    {
        top: "主要指標",
        sub: [
            { name: "売上", groups: ["売上"] },
            { name: "アクセス人数", groups: ["アクセス人数"] },
            { name: "売上件数", groups: ["売上件数"] },
            { name: "転換率", groups: ["転換率"] },
            { name: "客単価", groups: ["客単価"] },
        ],
    },
    { top: "限界利益", groups: ["限界利益"], rowSpan2: true },
    { top: "固定費", groups: ["固定費"], rowSpan2: true },
    { top: "営業利益", groups: ["営業利益"], rowSpan2: true },
    { top: "費用合計", groups: ["費用合計"], rowSpan2: true },
    {
        top: "費用内訳",
        sub: [
            { name: "原価", groups: ["原価"] },
            { name: "手数料", groups: ["手数料"] },
            { name: "物流コスト", groups: ["物流コスト"] },
            { name: "販促費", groups: ["販促費"] },
            { name: "楽天広告費内訳", groups: ["楽天広告費内訳"] },
            { name: "楽天外広告費内訳", groups: ["楽天外広告費①", "楽天外広告費②", "楽天外広告費③"] },
        ],
    },
] as const;

// import 側で `type HeaderSection` が必要ならこれを使う
export type HeaderSection = (typeof HEADER_STRUCTURE)[number];
